<template>
    <b-modal
        id="school-account-add-user"
        v-model="user_modal"
        hide-footer
        :title="$t('school.new_user')"
        autocomplete="off">
        <div class="row">
            <div class="col-md-12">
                <b-form-group
                    :label="$t('common.first_name')"
                    label-for="name">
                    <b-form-input
                        id="name"
                        v-model="form.name"
                        required
                        :placeholder="$t('common.first_name')"></b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.name"
                        >@{{ allerrors.name[0] }}</label
                    >
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <b-form-group
                    :label="$t('common.infix')"
                    label-for="preposition">
                    <b-form-input
                        id="preposition"
                        v-model="form.preposition"
                        :placeholder="$t('common.infix')"></b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.preposition"
                        >@{{ allerrors.preposition[0] }}</label
                    >
                </b-form-group>
            </div>
            <div class="col-md-8">
                <b-form-group
                    :label="$t('common.last_name')"
                    label-for="surname">
                    <b-form-input
                        id="surname"
                        v-model="form.surname"
                        required
                        :placeholder="$t('common.last_name')"></b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.surname"
                        >@{{ allerrors.surname[0] }}</label
                    >
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <b-form-group
                    label="E-mail:"
                    label-for="email">
                    <b-form-input
                        id="email"
                        v-model="form.email"
                        type="email"
                        required
                        placeholder="E-mail"></b-form-input>
                </b-form-group>
                <label
                    class="error mt-2 text-danger"
                    v-if="allerrors.email"
                    >@{{ allerrors.email[0] }}</label
                >
            </div>
        </div>

        <b-form-group
            label="Rol:"
            label-for="role">
            <b-form-select
                class="mb-3"
                v-model="form.role"
                required>
                <option value="student">{{ $t('school.student') }}</option>
                <option value="teacher">{{ $t('school.teacher') }}</option>
            </b-form-select>
            <label
                class="error mt-2 text-danger"
                v-if="allerrors.role"
                >@{{ allerrors.role[0] }}</label
            >
        </b-form-group>

        <b-form-group
            :label="$t('common.username')"
            label-for="username">
            <b-form-input
                id="username"
                v-model="form.username"
                required
                :placeholder="$t('common.username')"></b-form-input>
            <label
                class="error mt-2 text-danger"
                v-if="allerrors.username"
                >@{{ allerrors.username[0] }}</label
            >
        </b-form-group>

        <b-form-group
            :label="$t('common.password')"
            label-for="password">
            <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                required
                autocomplete="new-password"
                :placeholder="$t('common.password')"></b-form-input>
            <label
                class="error mt-2 text-danger"
                v-if="allerrors.password"
                >@{{ allerrors.password[0] }}</label
            >
        </b-form-group>

        <b-button
            @click="onSubmit()"
            variant="success"
            >{{ $t('common.save') }}</b-button
        >
        <b-button
            @click="onReset()"
            variant="danger"
            >Reset</b-button
        >
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-school-accounts-add-account-modal-component',
    data() {
        return {
            user_modal: false,
            form: {
                id: '',
                name: '',
                preposition: '',
                surname: '',
                email: '',
                username: '',
                password: '',
                role: '',
            },
            allerrors: {},
        };
    },
    methods: {
        onShow() {
            this.onReset();
        },
        onReset() {
            this.form.id = null;
            this.form.name = null;
            this.form.email = null;
            this.form.preposition = null;
            this.form.surname = null;
            this.form.username = null;
            this.form.role = null;
            this.allerrors = {};
        },
        onSubmit() {
            this.alert.saving();

            this.axios
                .post('/project/account/store', this.form)
                .then((response) => {
                    this.user_modal = false;
                    this.alert.success();
                    this.$emit('user-created');
                })
                .catch((error) => {
                    if (error.response) {
                        this.alert.close();
                        this.allerrors = error.response.data.errors;
                    } else {
                        if (error.response.data.errors.email || error.response.data.errors.username) {
                            if (error.response.data.errors.email) {
                                this.emailDuplicateError = true;
                            } else {
                                this.emailDuplicateError = false;
                            }

                            if (error.response.data.errors.username) {
                                this.usernameDuplicateError = true;
                            } else {
                                this.usernameDuplicateError = false;
                            }

                            this.alert.close();
                        } else {
                            this.alert.ajaxError(error);
                        }
                    }
                });
        },
    },
};
</script>

<style scoped></style>
